import { render, staticRenderFns } from "./PanelRole.vue?vue&type=template&id=3c7bf594&"
import script from "./PanelRole.vue?vue&type=script&lang=js&"
export * from "./PanelRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports